import { s3Parser } from 's3u';

export const S3_SERVICES = [
  'amazonaws.com',
  'cloudflarestorage.com',
  'digitaloceanspaces.com',
] as const;
export type S3ServiceName = (typeof S3_SERVICES)[number];

export const STORAGE_SERVICES = [
  ...S3_SERVICES,
  'bunnycdn.com',
  'pulsecdn.net',
] as const;
export type StorageServiceName = (typeof S3_SERVICES)[number];

export const CDN_PROVIDERS = ['bunnycdn'] as const;

export const ProviderMap: Record<ServiceProvider, ProviderType> = {
  'amazonaws.com': 'storage',
  'bunnycdn.com': 'storage',
  'cloudflarestorage.com': 'storage',
  'digitaloceanspaces.com': 'storage',
  'pulsecdn.net': 'storage',

  'shopify': 'webhook',
  'squarespace': 'webhook',

  'wix': 'webhook',

  'cdn': 'cdn',
} as const;

export function groupByProvider<T extends { provider: ServiceProvider }>(
  items: T[],
): Record<ProviderType, T[]> {
  const collection = { storage: [] as T[], webhook: [] as T[], cdn: [] as T[] };

  items.forEach((item) => {
    const providerType = ProviderMap[item.provider];
    if (providerType && collection[providerType]) {
      collection[providerType].push(item);
    }
  });

  return collection;
}

export function getStorageProvidersInfo(): ProviderInfo[] {
  const dict = S3_SERVICES.map((providerId) => {
    const provider = s3Parser.getProviderById(providerId);
    return {
      value: providerId,
      label: provider?.title || providerId,
    };
  }) as ProviderInfo[];

  dict.push(
    { label: 'PulseCDN', value: 'pulsecdn.net' },
    { label: 'PulseCloud', value: 'bunnycdn.com' },
  );

  return dict;
}

export function getCdnProvidersInfo(): ProviderInfo[] {
  return [{ label: 'BunnyCDN', value: 'bunnycdn' }];
}

export type StorageProvider = (typeof STORAGE_SERVICES)[number];
export type CdnProvider = (typeof CDN_PROVIDERS)[number];

export type WebhookProvider = 'shopify' | 'squarespace' | 'wix';
export type ServiceProvider = 'cdn' | StorageProvider | WebhookProvider;

export type ProviderType = 'cdn' | 'storage' | 'webhook';

export interface ProviderInfo {
  label: string;
  value: string;
}
